import { ContractScopeOfWorkAddDialogConfig } from "../contract/components/contract-scope-of-work-add-dialog";

export const omniContractScopeOfWorkAddDialogConfig: ContractScopeOfWorkAddDialogConfig =
  {
    selectBaseData: false,
  };
